var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.items.length > 0)?_c('div',{staticClass:"C-block-type-102"},[_vm._l((_vm.blocks),function(blocks,index){return [_c(blocks.name,{key:index,tag:"component",attrs:{"data":blocks.data,"settings":blocks.settings}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }